import React, { useState } from "react";
import "./CustomSwitch.css"; // Importing the custom CSS file

const CustomSwitch = ({ defaultChecked, id, onSwitch, color }) => {
  const [isActive, setIsActive] = useState(defaultChecked ?? false);

  const toggleSwitch = () => {
    setIsActive(!isActive);
    onSwitch(!isActive);
  };

  return (
    <label className="custom__switch_btn" htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        checked={isActive}
        onChange={toggleSwitch}
      />
      <span
        className="custom__switch_slider"
        style={{ background: isActive ? color ?? "#1d4266" : "" }}
      ></span>
    </label>
  );
};

export default CustomSwitch;
